import { jqHeaderMenu } from './modules/jqHeaderMenu';
import { jqHeaderHeight } from './modules/jqHeaderHeight';
import { movileTelLink } from './modules/movileTelLink';
import { jsScroll } from './modules/jsScroll';
import { smoothScroll } from './modules/smoothScroll';
import { tabletViewport } from './modules/tabletViewport';
import { slider } from './modules/slider';
import { jqAccordion } from './modules/jqAccordion';
import { inview_setting } from './modules/inview_setting';
import { jqSidebar } from './modules/jqSidebar';
import { brandSearch } from './modules/brandSearch';
import { common } from './modules/common';
import { countNum } from './modules/countNum';


// import { scrollmagic } from './modules/scrollmagic';
// window.addEventListener('load', () => {
//   //crollに応じてアニメーションしたい時
//   scrollmagic();

//   //crollによる処理を間引きしたい時
//   // scrollAction();
// });


jqHeaderMenu();
jqHeaderHeight();
movileTelLink();
jsScroll();
smoothScroll();
tabletViewport();
slider();
jqAccordion();
inview_setting();
jqSidebar();
brandSearch();
common();
countNum();